import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { RadabankOnboardingContent } from 'components/RadabankCard';
import { ArrowBackButton, CustomButton } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL } from 'utils/enums';
import { FirebaseAnalytics } from 'utils/services';

export const RadabankAuthInfoDocumentsSubmissionPage: FC = () => {
	const history = useHistory();

	const handleGoBack = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.DOCUMENTS_SUBMISSION,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
		);
		history.push(ROUTER_URL.PROFILE);
	};

	return (
		<div className="host-card-page-color-primary">
			<ArrowBackButton onClick={handleGoBack} />
			<RadabankOnboardingContent
				title="Надання документів"
				description={[
					'Надані документи вимагають додаткової перевірки.',
					'Ви отримаєте повідомлення, коли все буде готово',
				]}
			/>
			<CustomButton label="Повернутись" color="secondary" onClick={handleGoBack} />
		</div>
	);
};
